import {
  ODataHeader,
  ODataString,
  ODataDecimal,
  ODataInteger,
  ODataEnum,
  ODataBoolean,
} from "pbas-vue-components";

import { translate2 } from "../trans2";

export default [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    sortable: false,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "PlanId",
    type: new ODataString("PlanId"),
    sortable: false,
    visible: false,
    searchable: false,
    isIdentifier: false,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Translations[]", {
      getString: (item) => translate2(item, "GoogleSearchName"),
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "globals.active",
    type: new ODataBoolean("IsActive"),
    sortable: true,
    visible: true,
    searchable: true,
  })
];
